import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import {
    translateFormFieldLabel,
    translateFormFieldValue,
} from '../../../../../../../helpers/collaborativeIndexations'
import Select from '../../../../Forms/Commons/Select'
import { GenderContainer } from '../../Commons/Gender'
import { ProfessionContainer } from '../../Commons/Profession'

class More extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.updateFieldValueFromEvent = this.updateFieldValueFromEvent.bind(this)
        this.updateFieldValueFromSelectedOption = this.updateFieldValueFromSelectedOption.bind(this)
    }

    updateFieldValueFromEvent(field)
    {
        return event => this.props.updateFieldValue(field, event.target.value)
    }

    updateFieldValueFromSelectedOption(field, option)
    {
        this.props.updateFieldValue(field, option.value)
    }

    render()
    {
        const { t, fields } = this.props

        return (
            <div>
                { t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_civil_registry.steps.more.title') }

                <GenderContainer hasFocus={true} />
                <ProfessionContainer />
                <div className={'form-group'}>
                    <label>{ translateFormFieldLabel(t, 'relationship') }</label>
                    <Select
                        options={[
                            {value: '', label: translateFormFieldValue(t, 'relationship', 'default')},
                            {value: 'main', label: translateFormFieldValue(t, 'relationship', 'main')},
                            {value: 'wife', label: translateFormFieldValue(t, 'relationship', 'wife')},
                            {value: 'husband', label: translateFormFieldValue(t, 'relationship', 'husband')},
                            {value: 'mother', label: translateFormFieldValue(t, 'relationship', 'mother')},
                            {value: 'father', label: translateFormFieldValue(t, 'relationship', 'father')},
                            {value: 'daughter', label: translateFormFieldValue(t, 'relationship', 'daughter')},
                            {value: 'son', label: translateFormFieldValue(t, 'relationship', 'son')},
                            {value: 'sister', label: translateFormFieldValue(t, 'relationship', 'sister')},
                            {value: 'brother', label: translateFormFieldValue(t, 'relationship', 'brother')},
                            {value: 'other', label: translateFormFieldValue(t, 'relationship', 'other')},
                        ]}
                        value={fields.relationship === null ? '' : fields.relationship}
                        onChange={ option => this.updateFieldValueFromSelectedOption('relationship', option) }
                        isSearchable={true}
                    />
                </div>
            </div>
        )
    }
}

export default withTranslation()(More)
